export enum TypeDeDocEnum {
    facture = 0,
    avoir = 1
}
